module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_funabashi-842891c818f9cc7570ed74a5dc50cbfd.jpg";